<template>
  <div>
    <a @click="fnShowModal()" class="p-2"
      ><i class="far fa-edit text-primary"></i
    ></a>

    <b-modal ref="modal" size="xl" hide-footer title="Dealer - edit">
      <div class="d-block">
        <form v-on:submit.prevent="fnUpdate">
          <div class="row">
            <div class="col-12 col-md-4 col-lg-4">
              <p class="fw-600 fs-100 text-info">Company information</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder=" "
                  autocomplete="off_name"
                  v-model="name"
                />
                <label class="floatingLabel" for="name">Dealer name</label>
                <div class="invalid-feedback" v-if="errors.name">
                  {{ errors.name[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_abn"
                  v-model="abn"
                />
                <label class="floatingLabel" for="suburb">ABN</label>
              </div>

              <div class="form-group">
                <b-form-select
                  plain
                  :options="dealerBrokerageList"
                  value-field="value"
                  text-field="text"
                  placeholder=" "
                  autocomplete="off_dealerBrokerage"
                  v-model="dealerBrokerage"
                ></b-form-select>
                <label class="floatingLabel" for="dealerBrokerage"
                  >Reporting Commission</label
                >
              </div>

              <div class="form-group">
                <b-form-select
                  plain
                  :options="referredLeadCommissionList"
                  value-field="value"
                  text-field="text"
                  placeholder=" "
                  autocomplete="off_referredLeadCommissionList"
                  v-model="referredLeadCommission"
                ></b-form-select>
                <label class="floatingLabel" for="referredLeadCommissionList"
                  >Referred Lead Commission</label
                >
              </div>

              <div class="form-group">
                <b-form-select
                  plain
                  :options="getAllBDMs"
                  value-field="id"
                  text-field="firstName"
                  placeholder=" "
                  autocomplete="off_referredByBDM"
                  v-model="referredByBDM"
                ></b-form-select>
                <label class="floatingLabel" for="referredByBDM"
                  >Referred by BDM</label
                >
              </div>

              <div class="form-group">
                <div class="d-flex flex-row">
                  <label class="pr500" for="status">Status</label>
                  <b-form-checkbox
                    switch
                    id="checkbox-1"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0"
                    v-model="status"
                  >
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 col-lg-4">
              <p class="fw-600 fs-100 text-info">Address</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="street"
                  placeholder=" "
                  autocomplete="off_street"
                  v-model="street"
                />
                <label class="floatingLabel" for="street">St. address</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="suburb"
                  placeholder=" "
                  autocomplete="off_suburb"
                  v-model="suburb"
                />
                <label class="floatingLabel" for="suburb">Suburb</label>
                <div class="invalid-feedback" v-if="errors.suburb">
                  {{ errors.suburb[0] }}
                </div>
              </div>
              <div class="form-group">
                <b-form-select
                  plain
                  :options="optionsStates"
                  value-field="code"
                  text-field="name"
                  placeholder=" "
                  autocomplete="off_state"
                  v-model="state"
                ></b-form-select>
                <label class="floatingLabel" for="state">State</label>
                <div class="invalid-feedback" v-if="errors.state">
                  {{ errors.state[0] }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="postCode"
                  placeholder=" "
                  autocomplete="off_postCode"
                  v-model="postCode"
                />
                <label class="floatingLabel" for="postCode">Post code</label>
                <div class="invalid-feedback" v-if="errors.postCode">
                  {{ errors.postCode[0] }}
                </div>
              </div>
            </div>

            <div class="col-12 col-md-4 col-lg-4">
              <p class="fw-600 fs-100 text-info">Bank information</p>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_bsb"
                  v-model="bsb"
                />
                <label class="floatingLabel" for="bsb">BSB</label>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_accountName"
                  v-model="accountName"
                />
                <label class="floatingLabel" for="accountName"
                  >Account name</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_accountNumber"
                  v-model="accountNumber"
                />
                <label class="floatingLabel" for="accountNumber"
                  >Account number</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_phone"
                  v-model="accountFullName"
                />
                <label class="floatingLabel" for="suburb"
                  >Account contact full name</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_email"
                  v-model="accountEmail"
                />
                <label class="floatingLabel" for="email"
                  >Account contact email</label
                >
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_accountSecondEmail"
                  v-model="accountSecondEmail"
                />
                <label class="floatingLabel" for="accountSecondEmail"
                  >Account contact secondary email</label
                >
              </div>

              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder=" "
                  autocomplete="off_phone"
                  v-model="accountPhone"
                />
                <label class="floatingLabel" for="suburb"
                  >Account contact phone</label
                >
              </div>
            </div>
          </div>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-dark btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-sm">Update</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import * as messageService from '../../../services/message.service'
import * as dealerService from '../../../services/dealer.service'
import {
  states,
  dealerBrokerageList,
  referredLeadCommissionList
} from '../../../services/data.service'
export default {
  name: 'ModelDealerEdit',
  props: ['propsData'],
  components: {},
  data() {
    return {
      errors: {},
      id: '',
      name: '',
      street: '',
      suburb: '',
      state: '',
      postCode: '',
      status: '',
      accountFullName: '',
      accountEmail: '',
      accountSecondEmail: '',
      accountPhone: '',
      bsb: '',
      accountNumber: '',
      accountName: '',
      abn: '',
      dealerBrokerage: 0.05,
      referredLeadCommission: 0.0,
      referredByBDM: '',
      dealerBrokerageList: dealerBrokerageList,
      referredLeadCommissionList: referredLeadCommissionList,
      optionsStates: states
    }
  },
  computed: {
    ...mapGetters(['getDealerPaginate', 'getAllBDMs'])
  },
  methods: {
    ...mapActions(['fetchDealerPaginate', 'fetchAllBDMs']),
    fnShowModal() {
      this.fetchAllBDMs()
      this.fnGetSingle(this.propsData)
      this.showModal()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnGetSingle: async function (props) {
      try {
        this.id = props.id
        this.name = props.name
        this.street = props.street
        this.suburb = props.suburb
        this.state = props.state
        this.postCode = props.postCode
        this.status = props.status
        this.accountFullName = props.accountFullName
        this.accountEmail = props.accountEmail
        this.accountSecondEmail = props.accountSecondEmail
        this.accountPhone = props.accountPhone
        this.bsb = props.bsb
        this.accountNumber = props.accountNumber
        this.accountName = props.accountName
        this.abn = props.abn
        this.dealerBrokerage = props.dealerBrokerage
        this.referredLeadCommission = props.referredLeadCommission
        this.referredByBDM = props.referredByBDM
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Dealer - update',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Dealer - update',
              'Something wrong'
            )
            break
        }
      }
    },
    fnUpdate: async function () {
      const obj = {
        name: this.name,
        street: this.street,
        suburb: this.suburb,
        state: this.state,
        postCode: this.postCode,
        accountFullName: this.accountFullName,
        accountEmail: this.accountEmail,
        accountSecondEmail: this.accountSecondEmail,
        accountPhone: this.accountPhone,
        bsb: this.bsb,
        accountNumber: this.accountNumber,
        accountName: this.accountName,
        abn: this.abn,
        dealerBrokerage: this.dealerBrokerage,
        referredLeadCommission: this.referredLeadCommission,
        referredByBDM: this.referredByBDM,
        status: this.status
      }
      try {
        const response = await dealerService.update(this.id, obj)
        this.fetchDealerPaginate(this.getDealerPaginate)
        messageService.fnSweetAlertSuccessToast(
          'Dealer',
          'Updated successfully'
        )
        this.hideModal()

        this.id = ''
        this.name = ''
        this.street = ''
        this.suburb = ''
        this.state = ''
        this.postCode = ''
        this.accountFullName = ''
        this.accountEmail = ''
        this.accountSecondEmail = ''
        this.accountPhone = ''
        this.bsb = ''
        this.accountNumber = ''
        this.accountName = ''
        this.abn = ''
        this.dealerBrokerage = 0.05
        this.referredLeadCommission = 0.0
        this.referredByBDM = ''
        this.status = ''
        this.editUserSatus = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Dealer - update',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Dealer - update',
              'Something wrong'
            )
            break
        }
      }
    }
  }
}
</script>
